import React, { useState, useEffect } from "react";
import styled from "styled-components";

import FormGroup from "live/components/forms/ui/form-group";
import SubmitOrCancel from "live/components/forms/ui/submit-or-cancel";

import UserGroupBox from "./UserGroupBox";
import {
  createPesrpectiveApi,
  updatePesrpectiveApi,
} from "../../../api/perspectiveApi";
import i18n from 'live/services/i18n';

const Perspective = ({
  perspective,
  company,
  selectPerspective,
  reloadPerspectiveList,
}) => {
  const [messageErrorName, setMessageErrorName] = useState("");
  const [messageErrorResponseApi, setMessageErrorResponseApi] = useState();
  const [perspectiveSelected, setPerspectiveSelected] = useState({
    name: "",
    description: "",
    groups: [],
  });

  useEffect(() => {
    if (perspective.id) {
      setPerspectiveSelected(perspective);
    }
  }, []);

  const addGroup = (group) => {
    setPerspectiveSelected({
      ...perspectiveSelected,
      groups: [group, ...perspectiveSelected.groups],
    });
  };

  const removeGroup = (groupToRemove) => {
    setPerspectiveSelected({
      ...perspectiveSelected,
      groups: perspectiveSelected.groups.filter((group) => {
        return group.id != groupToRemove.id;
      }),
    });
  };

  const saveNewPerspective = () => {
    const canSave = validName(perspectiveSelected.name);

    if (canSave) {
      if (perspectiveSelected.id) {
        updateDB(perspectiveSelected);
      } else {
        saveDB(perspectiveSelected);
      }
    }
  };

  const saveDB = (perspective) => {
    perspective.companyID = company.id;

    createPesrpectiveApi(perspective)
    .then(() => {
      cancel();
    })
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    })
    ;
  };

  const updateDB = (perspective) => {
    updatePesrpectiveApi(perspective)
    .then((response) => {
        cancel();
    })
    .catch(error => {
      setMessageErrorResponseApi(error?.response?.data?.message || error?.response?.data);
    })
    ;
  };

  const validName = (name) => {
    let isValid = true;
    setMessageErrorName("");

    if (name === "") {
      setMessageErrorName("Name can't be empty");
      isValid = false;
    }

    return isValid;
  };

  const _handleOnChangeName = (event) => {
    const name = event.target.value;
    validName(name);
    setPerspectiveSelected({
      ...perspectiveSelected,
      name: event.target.value,
    });
  };

  const cancel = () => {
    selectPerspective(null);
    reloadPerspectiveList();
  };

  return (
    <PerspectiveBox>
      <div className="perspective-data">
        <FormGroup
          className={messageErrorName !== "" ? "custom-form-group-danger" : ""}
          type="text"
          disabled={false}
          label="Name"
          value={perspectiveSelected.name}
          onChange={_handleOnChangeName.bind(this)}
          help={messageErrorName !== "" ? i18n(messageErrorName) : ""}
        />
        <FormGroup
          type="text"
          disabled={false}
          label="Description (optional)"
          value={perspectiveSelected.description}
          onChange={(e) =>
            setPerspectiveSelected({
              ...perspectiveSelected,
              description: e.target.value,
            })
          }
        />
        <SubmitOrCancel
          disabled={false}
          // saving={null}
          // saved={null}
          // error={null || null}
          // mustSave={null}
          // valid={null}
          onSubmit={() => saveNewPerspective()}
          onCancel={() => cancel()}
          hideCancel={false}
        />

        <div class="custom-form-group-danger">
          <span class="custom-form-group-danger help-block">{messageErrorResponseApi}</span>
        </div>
      </div>
      <div className="perspective-users-group">
        {perspectiveSelected.id != company.perspectiveId ? (
          <UserGroupBox
            company={company}
            perspective={perspectiveSelected}
            addGroup={addGroup}
            removeGroup={removeGroup}
          />
        ) : null}
      </div>
    </PerspectiveBox>
  );
};

const PerspectiveBox = styled.div`
  width: 100%;
  padding: 20px;
  display: flex;

  .perspective-data {
    flex: 1 1 auto;
    padding: 20px;
  }

  .perspective-users-group {
    flex: 0 1 300px;
  }
`;

export default Perspective;
